import React from 'react';
import styled from 'styled-components';
import { IconSingleSparkle } from '@bynder/icons';
import { publish } from '@bynder/micro-frontend-communication';
import { useTranslate } from '@bynder/localization';
import { useMemoizedSplit } from '../../helpers/useSplit';

const ConversationalAIButton = styled.button`
	cursor: pointer;
	background: none;
	border: none;
	height: 50px;
	font-size: 22px;
	line-height: 50px;
	padding: 0 8px;
	box-sizing: border-box;
	transition: box-shadow 0.2s ease-in-out;
	border-radius: var(--brandRadiusBase-v7-11-2);

	:focus {
		box-shadow: inset 0 0 0 3px var(--gray75-v8-0-2);
	}

	/*
		Ensuring the gradient required for the Conversational AI button isn't shown anywhere.
		We want to use the SVG from @bynder/icons so we create a separate SVG to hold
		the gradient required then apply that gradient to the original icon SVG.
	*/
	.conai-gradient-container {
		position: absolute;
		width: 0;
		height: 0;
		visibility: hidden;
	}

	path {
		fill: url(#conai-header-gradient);
	}
`;

export function ConversationalAI() {
	const showConversationalAI = useMemoizedSplit('cw_conversational_ai_header_button');
	const { translate } = useTranslate();

	if (!showConversationalAI) {
		return null;
	}

	return (
		<li id="conversationalAiButton">
			<ConversationalAIButton
				type="button"
				aria-label={translate('conversationalAi.toggleSidebar')}
				onClick={() => {
					publish('conversational-ai/toggle-sidebar');
				}}
			>
				<IconSingleSparkle />
				<svg className="conai-gradient-container">
					<defs>
						<linearGradient id="conai-header-gradient" gradientTransform="rotate(0)">
							<stop offset="0%" stopColor="#126DFE" />
							<stop offset="50%" stopColor="#B080EF" />
							<stop offset="100%" stopColor="#A1ACFF" />
						</linearGradient>
					</defs>
				</svg>
			</ConversationalAIButton>
		</li>
	);
}
